module.exports = __webpack_public_path__ + "static/media/Fox-Hollow-Bylaws.716a6401.pdf";